import { Verified } from '@shared/icons/system';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { UnsubscribePageContainer } from '..';
import { Link } from '../../Link/Link';

/**
 * Component to display a success screen when the unsubscribe data is saved successfully
 * @returns A component to display a success screen when the unsubscribe data is saved successfully
 */
function UnsubscribeScreenSuccess() {
  const t = useTranslations('unsubscribe');
  const { HOME } = ROUTES;
  return (
    <UnsubscribePageContainer data-track-container="Update Confirmation">
      <UnsubscribePageContainer.NotificationContainer data-testid="unsubscribe-success-screen">
        <Verified size="extra-extra-large" className="self-center" />
        <p className="text-center">{t('success.message')}</p>
        <div className="flex items-center gap-1 justify-center">
          <p>{t('success.visit')}</p>
          <Link href={HOME} className="text-primary underline" data-track-name="Visit Site">
            {t('success.link')}
          </Link>
        </div>
      </UnsubscribePageContainer.NotificationContainer>
    </UnsubscribePageContainer>
  );
}

export { UnsubscribeScreenSuccess };
